import type { ColumnFiltersState } from '@tanstack/react-table'
import { RolodexFilterOp, type RolodexFilterType } from 'types'

export const FILTER_ID_TO_DATA_KEY = {
  title: 'title',
  documentTitle: 'document_title',
  system: 'system',
  drawing: 'drawing_number',
  vendor: 'vendor_name',
  docType: 'document_type',
} as const

export type BrowseFilterId = keyof typeof FILTER_ID_TO_DATA_KEY

export function isBrowseFilterId(id: string): id is BrowseFilterId {
  return Object.hasOwn(FILTER_ID_TO_DATA_KEY, id)
}

export function escapeForRolodexIlike(text: string): string {
  return text.replace(/\\/g, '\\\\').replace(/%/g, '\\%').replace(/_/g, '\\_')
}

export function scopedTagsIdentityKey(
  scopedTags: Record<string, string | string[]> | undefined
): string {
  if (scopedTags === undefined) return ''
  return JSON.stringify(scopedTags, Object.keys(scopedTags).sort())
}

function isNonEmptyFilterText(
  value: ColumnFiltersState[number]['value']
): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

function isNonEmptyFilterList(
  value: ColumnFiltersState[number]['value']
): value is string[] {
  return (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every((item) => typeof item === 'string')
  )
}

export function mapColumnFiltersToRolodexFilters(
  filters: ColumnFiltersState | undefined
): RolodexFilterType[] {
  const rolodexFilters: RolodexFilterType[] = []
  for (const { id, value } of filters ?? []) {
    if (!isBrowseFilterId(id)) continue
    const dataKey = FILTER_ID_TO_DATA_KEY[id]
    if (isNonEmptyFilterText(value)) {
      rolodexFilters.push({
        field: 'data',
        key: dataKey,
        op: RolodexFilterOp.REGEX,
        value: escapeForRolodexIlike(value.trim()),
      })
    } else if (isNonEmptyFilterList(value)) {
      rolodexFilters.push({
        field: 'data',
        key: dataKey,
        op: RolodexFilterOp.IN,
        value,
      })
    }
  }
  return rolodexFilters
}
